import { render, staticRenderFns } from "./select-task-assign.vue?vue&type=template&id=5d6b7d56&"
import script from "./select-task-assign.vue?vue&type=script&lang=ts&"
export * from "./select-task-assign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports